module.exports = __webpack_public_path__ + "static/media/mos-logo.0011ed68.svg";